/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { Container } from "react-awesome-styled-grid";
import { Heading } from "@nordcloud/gnui";
import { FlexContainer } from "~/components";

export function Maintenance() {
  return (
    <Container>
      <FlexContainer>
        <div>
          <Heading level={1} mb={0}>
            It&apos;s not your fault.
          </Heading>
          <Heading level={4}>
            The application is now being maintained. Try again in a few minutes.
          </Heading>
        </div>
      </FlexContainer>
    </Container>
  );
}
